/**
 * "策略中心/全渠道策略/指定商品专享规则" - 单对象 - 主子表表单联动
 * 1. 主-参与独享商品范围：
 *  包含：商品明细显示，店仓明细不显示
 *  排除：商品明细不显示，店仓明细显示
 *    1.1. 控制:子表表单-共享比例、保底库存数
 *    1.2. 控制:子表-共享比例、保底库存数
 *
 * #. 注意 详情初始化/刷新 时 的处理
 * #. 注意 隐藏了后还是占了位置，改表单项父级dom样式(display: flex)
 */

export default {
  mounted() {
    window.addEventListener("notificationOfMain", ({ detail }) => {
      this.subLinkChange01(detail)
    }, false);

  },
  updated() {
    if (vm.$route.params.tableName == 'SG_C_PRODUCT_EXCLUSIVE_STRATEGY') {
      this.initSubLinkChange01()
    }
  },
  methods: {
    subLinkChange01(_detail) {
      if (vm.$route.params.tableName == 'SG_C_PRODUCT_EXCLUSIVE_STRATEGY' && !vm.$route.fullPath.includes("/SYSTEM/TABLE/")) {
        let detail = _detail
        const page = vm.$store.state[R3.getModuleName()]
        if (!detail) { // 详情初始化/刷新
          let curVal = vm.$_live_getChildComponent(vm, `${vm.$route.params.tableName}PRO_RANGE_TYPE`).value // 取不到了？！！
          if (vm.$route.params.itemId == 'New') {
            curVal = vm.$store.state[R3.getModuleName()].updateData.SG_C_PRODUCT_EXCLUSIVE_STRATEGY.add.SG_C_PRODUCT_EXCLUSIVE_STRATEGY.PRO_RANGE_TYPE
          } else {
            curVal = vm.$store.state[R3.getModuleName()].updateData.SG_C_PRODUCT_EXCLUSIVE_STRATEGY.changeData.PRO_RANGE_TYPE
            if (!curVal) {
              curVal = vm.$store.state[R3.getModuleName()].updateData.SG_C_PRODUCT_EXCLUSIVE_STRATEGY.default.SG_C_PRODUCT_EXCLUSIVE_STRATEGY.PRO_RANGE_TYPE
            }
          }
          detail = {
            item: {colname: 'PRO_RANGE_TYPE', valuedata: curVal},
            PRO_RANGE_TYPE: curVal
          }
        }
        if (detail.item && detail.item.colname == "PRO_RANGE_TYPE") {
          console.log('指定商品专享规则-主子表联动::', detail);
          const sub = page.tabPanels[page.tabCurrentIndex].componentAttribute
          const nowTabForm = _.cloneDeep(sub.formData.data.inpubobj)
          const nowTabTable= _.cloneDeep(sub.tableData.data)
          let newData = {
            tabIndex: page.tabCurrentIndex,
            inpubobj: nowTabForm
          }
          const hideFn = function () {
            nowTabForm.forEach((it, dex) => {
              if (["RATIO", "QTY_MIN"].includes(it.colname)) {
                it._show = false
                it.isnotnull = false
              }
            });
            newData = {
              tabIndex: page.tabCurrentIndex,
              inpubobj: nowTabForm
            }
            nowTabTable.tabth.forEach((it, dex) => {
              if (["RATIO", "QTY_MIN"].includes(it.colname)) {
                it.hide = true
              }
            });
          }
          try {
            const _val = detail.PRO_RANGE_TYPE || detail.item.valuedata
            if (_val == 1 && sub.tableName == "SG_C_PRODUCT_EXCLUSIVE_STRATEGY_STORE_ITEM") {
              // 包含 && 店仓明细
              hideFn()
            } else if (_val == 2 && sub.tableName == "SG_C_PRODUCT_EXCLUSIVE_STRATEGY_ITEM") {
              // 排除 && 商品明细
              hideFn()
            } else {
              if (!['SG_C_PRODUCT_EXCLUSIVE_STRATEGY_STORE_ITEM', 'SG_C_PRODUCT_EXCLUSIVE_STRATEGY_ITEM'].includes(sub.tableName)) {
                // 防止动到操作日志等
                return
              }
              nowTabForm.forEach((it, dex) => {
                it._show = true
                if (["RATIO", "QTY_MIN"].includes(it.colname)) {
                  it.isnotnull = true
                }
              });
              if (nowTabTable && nowTabTable.tabth) {
                nowTabTable.tabth.forEach((it, dex) => {
                  it.hide = false
                });
              }
            }
            const loadingName = this.$route.meta.moduleName.replace(/\./g, '-');
            $store.commit(`${R3.getModuleName()}/updateFormDataForRefTable`, newData) // 更新子表-表单
            $store.commit(`${R3.getModuleName()}/updateTableListForRefTable`, nowTabTable) // 更新子表-表格
            this.$R3loading.hide(loadingName);
          } catch (e) {
            console.error(e);
          }
        }
      }
    },
    initSubLinkChange01: _.debounce(function() {
      this.subLinkChange01()
    }, 1200)
  }
}
